import { ArrayField, ShowProps, SingleFieldList } from "react-admin";
import { rowStyles } from "../Media/MediaListStyle";
import CastingConditionalImageField from "./CastingConditionalImageField";

const CastingGallery = (props: ShowProps) => {
  const classes = rowStyles();
  return (
    <>
      <div
        className={classes.imgGallery}
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 16,
          overflowY: "auto",
        }}
      >
        <ArrayField source="pictures">
          <SingleFieldList linkType={false}>
            <CastingConditionalImageField
              source="pictures"
              src="vignette_url"
              title="desc"
              label="casting pictures"
            />
          </SingleFieldList>
        </ArrayField>
      </div>
    </>
  );
};

export default CastingGallery;
